/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

angular.module('bulbApp.utilsModule')

/**
 * Our wrapper for http://fitvidsjs.com/ to enable our vimeo videos to display correctly.
 */
.directive('bulbFitVids', ['$interval', bulbFitVids]);

function bulbFitVids($interval) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      scope.videoReady = false;

      // We have to use an interval here because we don't know when the iframe exists, and we have to attach
      // the load event to it once it does.
      var handle = $interval(function() {
        if (element.find('iframe').length > 0) {
          $interval.cancel(handle);

          var loadHandler = element.find('iframe').load(function() {
            loadHandler.unbind();
            element.fitVids();
            scope.videoReady = true;
            scope.$apply();
          });
        }
      }, 100);
    }
  };
}
